import { Form, Input, Radio, Button, message, Upload } from 'antd';
import { UploadOutlined, CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import {AdminNewsApi} from "gmrfid-service-community-api-manager"
import { Wrap } from './style';
import ReactEditor from '../../components/Editor';
import moment from 'moment';
import { useHistory } from 'troyfe';
import defaultSettings from '@/defaultSettings';
import store from '@/store';
import { imgUrlHandle } from '@/utils';

message.config({
  maxCount: 1,
});
let lock = false;
const index = (props) => {
  const id = props.location.search.split('?')[1];
  const [appState] = store.useModel('app');
  const { appConfig } = appState;
  const [form] = Form.useForm();
  const history = useHistory();
  const [richData, setRichData] = useState({});
  const [content, setContent] = useState('');
  const [status, setStatus] = useState(false);
  const [newsData, setNewsData] = useState({});
  const [newsType, setNewsType] = useState('TW');
  const [newsStatus, setNewsStatus] = useState(1);
  const [video, setVideo] = useState([]);
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  const [value, setValue] = useState('');

  useEffect(() => {
    console.log(id);
    if (id) {
      getNewsDetail();
    } else {
      form.setFieldsValue({ contentType: 'TW' });
    }
  }, []);
  //获取新闻数据
  const getNewsDetail = () => {
   AdminNewsApi.detail({ form: { id: id } }).then((res) => {
      console.log(res.data.content);
      if (res.data.content != '' && res.data.contentType == 'SP') {
        const videoFile = res.data.content.split('\\')[2];
        console.log(videoFile.split('.'));
        setNewsType(res.data.contentType);
        console.log([{ name: videoFile.split('.')[0], prefix: videoFile.split('.')[1], path: res.data.files[0] }]);
        setVideo([{ name: videoFile.split('.')[0], prefix: 'video/mp4', path: res.data.files[0] }]);
      }
      setValue(res.data.content);
      form.setFieldsValue({ ...res.data });
    });
  };
  //提交数据
  const onFinish = (value) => {
    console.log(newsStatus);
    const data = document.getElementById('content');
    const newImg = [];
    if (!status) {
      data.style.visibility = 'hidden';
    }
    data.innerHTML = value.content;
    const imgs = data.getElementsByTagName('img');
    if (imgs) {
      for (let i = 0; i < imgs.length; i++) {
        newImg.push(imgs[i].currentSrc);
      }
    }
    const form = {
      ...value,
      files: value.contentType == 'TW' ? [...newImg] : [video[0].path],
      status: newsStatus ? 'YFB' : 'DFB',
      id: id ? id : null,
    };
    if (form.files.length == 0 && value.contentType == 'SP' && !value.content) {
      return message.error(`新闻标题或${newsType == 'TW' ? '内容' : '视频'}不能为空`);
    }
    console.log(form);
    AdminNewsApi.saveOrUpdate({ form }).then((res) => {
      if (res.status == 200) {
        history.push('/Journalism');
      }
    });
  };

  //进行预览
  const look = () => {
    const value = form.getFieldsValue(true);
    const data = document.getElementById('content');
    data.style.visibility = '';
    if (value?.title === undefined || !value?.content) {
      return message.error(`新闻标题或${newsType == 'TW' ? '内容' : '视频'}不能为空`);
    }
    if (newsType == 'TW') {
      data.innerHTML = value.content;
    }
    setStatus(true);
    setNewsData(value);
  };

  //切换新闻类型
  const changeType = (e) => {
    const data = document.getElementById('content');
    data.innerHTML = '';
    setNewsType(e.target.value);
    form.setFieldsValue({ content: '' });
    setVideo([]);
    setStatus(false);
    data.style.visibility = 'hidden';
    form.isFieldValidating(false);
  };

  //上传视频
  const props1 = {
    name: 'file',
    action: '/api/gmrfid-service-common/upload/upFileInfo',
    headers: {
      Authorization: `Bearer ${userInfo.token}`,
    },
    progress: {
      strokeColor: {
        '0%': '#108ee9',
        '100%': '#87d068',
      },
      strokeWidth: 3,
      format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
    },
    data: (file) => {
      return {
        fileName: file.name,
        suffix: file.type,
      };
    },
    beforeUpload(file) {
      console.log(file.type);
      const isJpgOrPng = file.type === 'video/quicktime' || file.type === 'video/avi' || file.type === 'video/mp4';
      console.log(isJpgOrPng);
      if (isJpgOrPng) {
        lock = true;
      } else {
        message.error('文件格式或大小异常!');
        lock = false;
      }
      return isJpgOrPng;
    },
    onChange(info) {
      if (lock) {
        if (info.file.status === 'uploading') {
          message.loading('正在上传......', 0);
        }
        if (info.file.status === 'done') {
          message.destroy();
          setVideo([{ name: info.file.name, path: info.file.response.fileUrl, prefix: info.file.type }]);
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} 上传异常.`);
        }
      }
    },
  };

  return (
    <Wrap>
      <div className="title">{id ? '编辑' : '新建'}新闻资讯</div>
      <div className="main">
        <div className="left">
          <Form
            // name="basic"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            onFinish={onFinish}
            className="form"
          >
            <Form.Item label="标题" name="title" rules={[{ required: true }]}>
              <Input style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="内容类型" name="contentType" rules={[{ required: true }]}>
              <Radio.Group
                value={newsType}
                onChange={(e) => {
                  changeType(e);
                }}
              >
                <Radio value="TW">图文内容</Radio>
                <Radio value="SP">视频内容</Radio>
              </Radio.Group>
            </Form.Item>
            {newsType == 'TW' ? (
              <Form.Item label="内容" name="content" rules={[{ required: true }]}>
                <ReactEditor
                  getHtmlData={value && value}
                  form={form}
                  setRichText={(v) => {
                    setValue(v);
                  }}
                  height={400}
                />
              </Form.Item>
            ) : (
              <Form.Item label="视频" name="content" rules={[{ required: true }]}>
                <div className="file-content" id="newContent">
                  {video.length < 1 && (
                    <div className="file-tip">
                      <Upload {...props1} showUploadList={false}>
                        <Button className="file-button">
                          上传文件
                          <UploadOutlined />
                        </Button>
                      </Upload>
                      <p className="file-text">支持扩展名：.MP4、.AVI、.MOV格式</p>
                    </div>
                  )}
                  <div className="fileImg">
                    {video.map((item, i) => (
                      <div key={i} className="img-box">
                        {/* <Spin indicator={antIcon} /> */}
                        <a>{item.name}</a>
                        <div
                          className="clear-img"
                          onClick={() => {
                            const index = video.indexOf(item);
                            if (index > -1) {
                              const newVideo = video;
                              newVideo.splice(index, 1);
                              setVideo([...newVideo]);
                            }
                          }}
                        >
                          <CloseCircleOutlined />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Form.Item>
            )}
            <Form.Item className="buttonBox">
              <Button
                onClick={() => {
                  history.push('/Journalism');
                }}
              >
                取消
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => {
                  setNewsStatus(0);
                }}
              >
                暂存
              </Button>
              <Button onClick={look}>预览</Button>
              <Button
                type="primary"
                htmlType="submit"
                className="ok"
                onClick={() => {
                  setNewsStatus(1);
                }}
              >
                发布
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className="right">
          {status && (
            <>
              <div className="header">
                <img src="/previousMonth.png" />
                <div>新闻详情</div>
              </div>
              <div className="title">{newsData.title}</div>
              <div className="time">
                {appConfig?.title}:{moment().format('YYYY-MM-DD HH:mm:ss')}
              </div>
            </>
          )}
          <div id="content" className="content">
            {newsType == 'SP' && status && video.length > 0 && (
              <video controls="controls">
                <source
                  src={imgUrlHandle(video[0].path)}
                  type={
                    video[0].prefix === 'video/quicktime'
                      ? 'video/mov'
                      : video[0].prefix === 'video/mp4'
                      ? 'video/mp4'
                      : video[0].prefix
                  }
                />
              </video>
            )}
          </div>
        </div>
      </div>
    </Wrap>
  );
};
export default index;
